import "./index.css";

export function App() {
  return (
    <div className="app">
      <p>
      Taiga Systems was founded to address a growing need in the world of autonomous systems—the need for machines that not only act, but know when they don’t know. Rooted in Scandinavian engineering traditions and the demands of defense and complex environments, we build autonomous solutions that operate with strategic intelligence. Our systems recognize when a situation is unfamiliar and when external input is required—whether navigating a defense scenario, driving in uncertain conditions, or encountering the unexpected at home. By embedding our own known-unknown models, we ensure that our autonomous systems constantly assess what’s known and what’s not, enhancing safety, adaptability, and trust in real time.
      </p>
    </div>
  );
}

export default App;
